/* =============================================================
   Blog — recommended tips grid
   ============================================================= */
import React from "react";
import { useLanguage } from "../contexts/LanguageContext";
import { marketingI18n } from "../content/homeMarketing";
import useScrollAnimate from "../hooks/useScrollAnimate";
import RecommendedGrid from "./marketing/RecommendedGrid";
import MarketingPageIntro from "./marketing/MarketingPageIntro";
import "./Home.css";
import "./MarketingPages.css";

export default function Blog() {
  const { lang } = useLanguage();
  const t = marketingI18n[lang];
  useScrollAnimate([lang]);

  return (
    <div className={`marketing-page ${lang === "ar" ? "rtl" : ""}`} dir={lang === "ar" ? "rtl" : "ltr"}>
      <MarketingPageIntro variant="blog" page={t.pages.blog} lang={lang} layout="split" />
      <RecommendedGrid t={t} lang={lang} />
    </div>
  );
}
